import { render } from "./meusDados.vue?vue&type=template&id=2e2828aa&scoped=true"
import script from "./meusDados.vue?vue&type=script&lang=js"
export * from "./meusDados.vue?vue&type=script&lang=js"

import "./meusDados.vue?vue&type=style&index=0&id=2e2828aa&lang=scss&scoped=true"

import exportComponent from "C:\\Projetos_Somasys\\Delivery\\DeliverySoma-SOLO.2023.10.27\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2828aa"]])

export default __exports__